import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import InvoicesTable from './InvoicesTable';

import { BillingActions } from '../../../Redux/modules/billing/actions';
import { BillingSelectors } from '../../../Redux/modules/billing/selectors';

const invoices = (props) => {
  const data = props.invoices;
  const columns = React.useMemo(
    () => [
      {
        Header: gettext('Issue Date'),
        accessor: 'created_at',
      },
      {
        Header: gettext('Product'),
        accessor: 'app',
      },
      {
        Header: gettext('Invoice'),
        accessor: 'invoice_file',
      },
      {
        Header: gettext('Amount'),
        accessor: 'grand_amount',
      },
      {
        Header: gettext('Paid'),
        accessor: 'amount_paid',
      },
      {
        Header: gettext('Balance'),
        accessor: 'balance',
      },
    ],
    [],
  );

  return (
    <div>
      <InvoicesTable
        isLoading={props.isLoading}
        data={data}
        columns={columns}
        tableProps={props}
        paginationObject={props.paginationObject}
        fetchInvoices={props.fetchInvoices}
        currentPage={props.currentPage}
        nextPage={props.nextPage}
        previousPage={props.previousPage}
        setPage={props.setPage}
      />
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    isLoading: BillingSelectors.isLoadingInvoicesSelector(state),
    paginationObject: BillingSelectors.paginationSelector(state),
    currentPage: BillingSelectors.billingPageSelector(state),
  };
};

const mapDispatchToProps = {
  setPage: BillingActions.setBillingPage,
  nextPage: BillingActions.billingNextPage,
  previousPage: BillingActions.billingPreviousPage,
};

invoices.propTypes = {
  isLoading: PropTypes.bool,
  invoices: PropTypes.array,
  paginationObject: PropTypes.object,
  fetchInvoices: PropTypes.func,
  setPage: PropTypes.func,
  nextPage: PropTypes.func,
  previousPage: PropTypes.func,
  currentPage: PropTypes.number,
};

export default connect(mapStateToProps, mapDispatchToProps)(invoices);
